import { render, staticRenderFns } from "./PurchaseCharge.vue?vue&type=template&id=22a66d88&"
import script from "./PurchaseCharge.vue?vue&type=script&lang=ts&"
export * from "./PurchaseCharge.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseCharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports